import React, { Component } from "react";
import { Modal, Form, Row, Col, Button, Tooltip, Radio, Table } from "antd";
import InputForm from "./InputForm";
import "./Form.css";
import ProdutoFrame from './ProdutoFrame';
import ServicoFrame from './ServicoFrame';
import numeral from "numeral";

const { Item: ItemForm } = Form;
const { Column } = Table;

export default class CheckListOSForm extends Component {
  state = {
    registro: {
      clos_idf: '',
      clos_descricao: '',
    }
  };


  componentDidUpdate(propsAnterior, stateAnterior) {
    if (this.props.registroSelecionado !== propsAnterior.registroSelecionado) {
      this.setState({
        registro: this.props.registroSelecionado.data,
        visualizar: this.props.registroSelecionado.visualizar,
        listaItens: this.props.registroSelecionado.listaItens
      }, () => {
        this.refs.clos_descricao.focus();
      });
    }
  }

  onChange = event => {
    const value = event.target.value;
    const id = event.target.id;
    const { registro } = this.state;
    registro[id] = value;
    this.setState({ [id]: value });
  };


  onOK = () => {
    if ((!this.state.registro.clos_descricao) || (this.state.registro.clos_descricao === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe a Descrição do CheckList' });
      return;
    }

    const reg = {
      clos_idf: this.state.registro.clos_idf,
      clos_descricao: this.state.registro.clos_descricao,
      listaItens: this.state.listaItens,
    }

    this.props.onSalvarClick(reg);
  };


  onNovoItem = () => {
    if (this.state.registro.tipoItem === 'P') {
      if ((!this.state.registro.closi_produto) || (this.state.registro.closi_produto.key === '0') || (this.state.registro.closi_produto.key === '')) {
        Modal.warning({ title: 'Aviso!', content: 'Informe o Produto', });
        return;
      }
    } else if (this.state.registro.tipoItem === 'S') {
      if ((!this.state.registro.closi_servico) || (this.state.registro.closi_servico.key === '0') || (this.state.registro.closi_servico.key === '')) {
        Modal.warning({ title: 'Aviso!', content: 'Informe o Serviço', });
        return;
      }
    } else if (this.state.registro.tipoItem === 'A') {
      if ((!this.state.registro.closi_avulso) || (this.state.registro.closi_avulso === '')) {
        Modal.warning({ title: 'Aviso!', content: 'Informe a Descrição do Item Avulso' });
        return;
      }
    }

    this.state.listaItens.push({
      closi_seq: this.state.listaItens.length + 1,
      closi_produto: this.state.registro.tipoItem === 'P' ? this.state.registro.closi_produto.idf : 0,
      closi_servico: this.state.registro.tipoItem === 'S' ? this.state.registro.closi_servico.key : 0,
      closi_avulso: this.state.registro.tipoItem === 'A' ? this.state.registro.closi_avulso : '',
      closi_valor: this.state.registro.tipoItem === 'P' ? this.state.registro.closi_produto.vlrVenda : this.state.registro.tipoItem === 'S' ? this.state.registro.closi_servico.serv_valor : this.state.registro.closi_valor,
      tipoItem: this.state.registro.tipoItem,
      codItem: this.state.registro.tipoItem === 'P' ? this.state.registro.closi_produto.idf : '',
      descItem: this.state.registro.tipoItem === 'P' ? this.state.registro.closi_produto.label : this.state.registro.tipoItem === 'S' ? this.state.registro.closi_servico.label : this.state.registro.closi_avulso,
    });

    this.setState({
      closi_produto: { key: '0' },
      closi_servico: { key: '0' },
      closi_avulso: '',
      closi_valor: 0,
      listaItens: this.state.listaItens
    });

  };

  onExcluirDescontoClick = (reg) => {
    Modal.confirm({
      title: 'Confirmação de Exclusão',
      content: `Deseja excluir este Item?`,
      okText: 'Sim',
      cancelText: 'Não',
      onOk: () => {
        const listaItens = [...this.state.listaItens];
        const index = listaItens.findIndex(registro => registro.closi_seq === reg.closi_seq);
        listaItens.splice(index, 1);
        this.setState({
          listaItens,
        });
      }
    })
  }

  renderAcoesProdutos = (registro) => {
    return (
      <Tooltip title="Excluir" placement="top">
        <Button type="danger" onClick={() => this.onExcluirDescontoClick(registro)} icon="delete" />
      </Tooltip>
    );
  };

  renderTipoItem = (tipo) => {
    return (
      <span> {tipo === 'P' ? 'Produto' : (tipo === 'S' ? 'Serviço' : 'Avulso')} </span>
    );
  };


  onChangeTipoItem = event => {
    const { registro } = this.state;
    registro['tipoItem'] = event.target.value;
    this.setState({ registro });
  };

  onChangeProduto = event => {
    const { registro } = this.state;
    registro['closi_produto'] = event.closi_produto;
    this.setState(event);
  }

  onChangeServico = event => {
    const { registro } = this.state;
    registro['closi_servico'] = {
      key: event.closi_servico.key,
      label: event.closi_servico.label,
      serv_valor: event.closi_servico.serv_valor,
    }
    this.setState(event);
  }

  renderValor = (vlr, registro) => {
    return (
      <span> {numeral(parseFloat(vlr)).format('0,000.00')} </span>
    );
  };






  render() {
    const { onCancelarClick, carregando, visivel } = this.props;
    const { clos_idf, clos_descricao, tipoItem, closi_produto, closi_servico, closi_avulso, closi_valor } = this.state.registro;
    const { listaItens } = this.state;

    // console.log('CheckListOSForm: ', this.state);

    return (
      <Modal
        title={clos_idf ? "Edição de CheckList" : "Cadastro de CheckList"}
        visible={visivel}
        destroyOnClose
        onCancel={onCancelarClick}
        footer={null}
        width={"60%"}
        style={{ top: 30 }}
      >
        <Form>
          <Row>
            <Col xs={24} sm={24}>
              <span>Descrição *</span>
              <InputForm
                id="clos_descricao"
                ref="clos_descricao"
                maxLength={30}
                onChange={this.onChange}
                value={clos_descricao}
                validator={value => Boolean(value)}
              />
            </Col>
          </Row>


          <Row style={{ marginBottom: 30 }}>
            <Row style={{ marginBottom: 20 }}>
              <span style={{ fontSize: 25 }}>Itens Vinculados ao CheckList</span>
            </Row>

            <Row>
              <Radio.Group onChange={this.onChangeTipoItem} value={tipoItem} >
                <Radio value={'P'}>Produto</Radio>
                <Radio value={'S'}>Serviço</Radio>
                <Radio value={'A'}>Avulso</Radio>
              </Radio.Group>
            </Row>

            <div>
              {tipoItem === 'P' ? (
                <Col xs={19} style={{ marginTop: 10 }}>
                  <ProdutoFrame
                    label="Produto"
                    id="closi_produto"
                    value={closi_produto}
                    width={"100%"}
                    onChange={this.onChangeProduto}
                  />
                </Col>
              ) : null}
              {tipoItem === 'S' ? (
                <Col xs={19} style={{ marginTop: 10 }}>
                  <span>Serviço</span>
                  <ServicoFrame
                    label=""
                    id="closi_servico"
                    value={closi_servico}
                    width={"100%"}
                    onChange={this.onChangeServico}
                    descricaoPrimeiroItem="Selecione um Serviço"
                  />
                </Col>
              ) : null}
              {tipoItem === 'A' ? (
                <div>
                  <Col xs={15} style={{ marginTop: 10 }}>
                    <span>Descrição do Item Avulso</span>
                    <InputForm
                      id="closi_avulso"
                      ref="closi_avulso"
                      value={closi_avulso}
                      placeholder="Informe a Descrição do Item Avulso"
                      maxLength={50}
                      onChange={this.onChange}
                      validator={value => Boolean(value)}
                    />
                  </Col>
                  <Col xs={4} style={{ marginTop: 10, paddingLeft: 20 }}>
                    <span>Valor</span>
                    <InputForm
                      type="number"
                      id="closi_valor"
                      ref="closi_valor"
                      value={closi_valor}
                      onChange={this.onChange}
                    />
                  </Col>
                </div>
              ) : null}
              <Col xs={24} sm={5} style={{ marginTop: 29 }}>
                <Button
                  type="primary"
                  htmlType="button"
                  onClick={this.onNovoItem}
                  icon="plus"
                  className="btn-primary"
                > Adicionar
                </Button>
              </Col>
            </div>




            <Col xs={24} sm={24}>
              <Table
                dataSource={listaItens}
                pagination={false}
                rowKey={(listaItens => listaItens.closi_seq)}
              >
                <Column
                  key="tipoItem"
                  dataIndex="tipoItem"
                  title="Tipo Item"
                  render={this.renderTipoItem}
                  width={60}
                  align="left"
                  className="listaCadastro"
                />
                <Column
                  key="codItem"
                  dataIndex="codItem"
                  title="Código"
                  width={60}
                  align="left"
                  className="listaCadastro"
                />
                <Column
                  key="descItem"
                  dataIndex="descItem"
                  title="Descrição"
                  width={250}
                  align="left"
                  className="listaCadastro"
                />
                <Column
                  key="closi_valor"
                  dataIndex="closi_valor"
                  title="Valor"
                  render={this.renderValor}
                  width={60}
                  align="left"
                  className="listaCadastro"
                />
                <Column
                  key="acoes"
                  title=""
                  render={this.renderAcoesProdutos}
                  width={30}
                  align="center"
                  className="listaCadastro"
                />
              </Table>
            </Col>
          </Row>


          <ItemForm>
            <Row>
              <Col xs={24}>
                {this.state.visualizar ? null : (
                  <Button
                    type="primary"
                    htmlType="button"
                    loading={carregando}
                    onClick={this.onOK}
                    className="btn-salvar"
                  >
                    Salvar
                  </Button>
                )}

                <Button
                  htmlType="button"
                  onClick={onCancelarClick}
                  className="btn-fechar"
                >
                  Fechar
                </Button>
              </Col>
            </Row>
          </ItemForm>

        </Form>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/CheckListOSForm.js